"use strict";
/**
 * Kushki SiftScience File
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiftScience = void 0;
const KushkiError_1 = require("./../../lib/generic/KushkiError");
const ErrorEnum_1 = require("./../../lib/infrastructure/ErrorEnum");
const SiftScienceEnum_1 = require("./../../lib/infrastructure/SiftScienceEnum");
const inversify_1 = require("inversify");
require("reflect-metadata");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const UtilsService_1 = require("./../../lib/service/UtilsService");
const uuid_1 = require("uuid");
/**
 * Kushki SiftScience Implementation
 */
let SiftScience = class SiftScience {
    constructor(regional) {
        this._siftProperty = "_sift";
        this._sift = [];
        this._initSiftScience(regional);
    }
    createSiftScienceSession(processor, clientIdentification, mid, isTest, merchantSettingsResponse, userId) {
        return rxjs_1.of(merchantSettingsResponse).pipe(operators_1.map((merchantSettings) => {
            if (UtilsService_1.UtilsService.sIsEmpty(window))
                return {
                    sessionId: null,
                    userId: null,
                };
            const sift_environment = isTest
                ? SiftScienceEnum_1.SiftScienceEnum.siftScienceTest
                : SiftScienceEnum_1.SiftScienceEnum.siftScienceProd;
            if (this._validateMerchantSettings(sift_environment, merchantSettings))
                return {
                    sessionId: null,
                    userId: null,
                };
            const user_id = userId || `${mid}${processor}${clientIdentification}`;
            const session_id = uuid_1.v4();
            this._setSiftProperties(merchantSettings, sift_environment, user_id, session_id);
            return {
                sessionId: session_id,
                userId: user_id,
            };
        }));
    }
    createSiftScienceAntiFraudSession(userId, mid, isTest, merchantSettingsResponse) {
        return rxjs_1.of(merchantSettingsResponse).pipe(operators_1.map((merchantSettings) => {
            if (UtilsService_1.UtilsService.sIsEmpty(window))
                return {
                    sessionId: null,
                };
            const sift_environment = isTest
                ? SiftScienceEnum_1.SiftScienceEnum.siftScienceTest
                : SiftScienceEnum_1.SiftScienceEnum.siftScienceProd;
            if (this._validateMerchantSettings(sift_environment, merchantSettings))
                throw new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E013);
            const user_id = `${userId}${mid}`;
            const session_id = uuid_1.v4();
            this._setSiftProperties(merchantSettings, sift_environment, user_id, session_id);
            return {
                sessionId: session_id,
            };
        }));
    }
    _validateMerchantSettings(siftEnvironment, merchantSettings) {
        return (merchantSettings[siftEnvironment] === "" ||
            merchantSettings[siftEnvironment] === null);
    }
    _setSiftProperties(merchantSettings, siftEnvironment, userId, sessionId) {
        this._sift =
            window[this._siftProperty] === undefined
                ? []
                : window[this._siftProperty];
        this._sift.push(["_setAccount", merchantSettings[siftEnvironment]]);
        this._sift.push(["_setUserId", userId]);
        this._sift.push(["_setSessionId", sessionId]);
        this._sift.push(["_trackPageview"]);
    }
    _initSiftScience(regional) {
        try {
            // istanbul ignore next
            if (!UtilsService_1.UtilsService.sIsEmpty(window)) {
                const e = window.document.createElement("script");
                e.src = regional
                    ? "https://regional-cdn.kushkipagos.com/siftscience/s.js"
                    : "https://cdn.siftscience.com/s.js";
                document.body.appendChild(e);
            }
        }
        catch (e) {
            // istanbul ignore next
            return;
        }
    }
};
SiftScience = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [Boolean])
], SiftScience);
exports.SiftScience = SiftScience;
